import React from "react";

// KIDH diamond-network mark — reusable SVG (approximation of the client's logo icon).
export const DiamondNetworkMark = ({ size = 48, tone = "orange", className = "" }) => {
  const orange = "#E8611A";
  const navy = "#0C2340";
  const white = "#FAFAF8";
  const stroke = tone === "white" ? white : tone === "navy" ? navy : orange;
  const dot = tone === "white" ? orange : tone === "navy" ? orange : navy;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Outer diamond */}
      <path
        d="M32 4 L60 32 L32 60 L4 32 Z"
        stroke={stroke}
        strokeWidth="2.2"
        fill="none"
      />
      {/* Nodes */}
      <circle cx="32" cy="14" r="2.6" fill={stroke} />
      <circle cx="50" cy="32" r="2.6" fill={stroke} />
      <circle cx="32" cy="50" r="2.6" fill={stroke} />
      <circle cx="14" cy="32" r="2.6" fill={stroke} />
      <circle cx="32" cy="32" r="3.4" fill={dot} />
      {/* Interconnections */}
      <path
        d="M32 14 L50 32 M50 32 L32 50 M32 50 L14 32 M14 32 L32 14 M32 14 L32 50 M14 32 L50 32"
        stroke={stroke}
        strokeOpacity="0.35"
        strokeWidth="1"
      />
    </svg>
  );
};

// Official client logo (image asset — new "clean" version)
export const KIDH_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_vision-landing-7/artifacts/qhd5k6at_3472EA0A-A761-4F6C-9324-77B0D49AF8BB.png";

// Full KIDH lockup: uses the official image asset. On dark backgrounds
// (`inverse`), it uses a `brightness-0 invert` filter to render a clean
// monochrome white version that preserves the diamond + wordmark shape.
export const KidhLogo = ({ inverse = false, className = "", useImage = false }) => {
  const navy = "#0C2340";
  const orange = "#E8611A";
  const white = "#FAFAF8";
  const textColor = inverse ? white : navy;
  const subColor = orange;

  if (useImage) {
    return (
      <img
        src={KIDH_LOGO_URL}
        alt="KIDH — Kipyz Design & Houses · Real Estate · Ensemble, vivons mieux."
        className={`h-40 w-auto object-contain ${
          inverse ? "brightness-0 invert" : ""
        } ${className}`}
        data-testid="kidh-logo"
      />
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="kidh-logo">
      <DiamondNetworkMark size={44} tone={inverse ? "white" : "navy"} />
      <div className="leading-none">
        <div
          className="font-heading font-black tracking-tight text-[1.4rem]"
          style={{ color: textColor, letterSpacing: "0.02em" }}
        >
          KIDH<span style={{ color: subColor }}>.</span>
        </div>
        <div
          className="font-body text-[0.55rem] uppercase mt-1"
          style={{ color: textColor, letterSpacing: "0.32em", opacity: 0.75 }}
        >
          Real Estate
        </div>
        <div
          className="font-body text-[0.5rem] mt-0.5 uppercase"
          style={{ color: subColor, letterSpacing: "0.18em" }}
        >
          Une filiale EKIP
        </div>
      </div>
    </div>
  );
};

export default KidhLogo;
